// extracted by mini-css-extract-plugin
export var card = "_kg-5";
export var cardSelected = "_kg-4";
export var image = "_kg-3";
export var modal = "_kg-0";
export var modalContent = "_kg-1";
export var table = "_kg-2";